import React, {Component} from 'react';
import axios from 'axios';
import {toast} from 'react-toastify';

export default class ModalDeleteRoomEvent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            roomEvent: null,
            loading: false
        }

        this.deleteOrActiveRoomEvent = this.deleteOrActiveRoomEvent.bind(this);
    }

    componentWillReceiveProps(props) {
        this.setState({
            roomEvent : props.roomEvent
        })
    }

    deleteOrActiveRoomEvent() {
        this.setState({
            loading: true
        });

        const requestData = {
            data: {
                id: this.state.roomEvent.id
            }
        }

        axios.post(global.config.apiDomain + '/mc-live-room/external/room-event/delete', JSON.stringify(requestData), {
            headers: {
                'Content-Type': 'application/json',
            },
        })
        .then(res => {
            this.setState({
                loading: false
            });

            if (res.data.status == "OK") {
                window.$("#modalDeleteRoomEvent").modal("hide");
                toast.success(res.data.message); 
                this.props.resetList();
            } else {
                toast.warning(res.data.message);
            }
        })
    }

    render() {

        const {roomEvent} = this.state;

        return (
            <div>
                <div className="modal fade" id="modalDeleteRoomEvent" tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog  modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                            {(roomEvent && !roomEvent.isRemoveByAdmin) ? (
                                 <h5 className="modal-title" id="exampleModalLabel">XÓA Sự Kiện</h5>
                            ) : ""}
                            {(roomEvent && roomEvent.isRemoveByAdmin) ? (
                                 <h5 className="modal-title" id="exampleModalLabel">HỦY XÓA Sự Kiện</h5>
                            ) : ""}
                               
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            {(roomEvent && !roomEvent.isRemoveByAdmin) ? (
                                <div className="modal-body">
                                <h3 className="text-center text-danger">Bạn chắc chắn muốn XÓA Sự Kiện: <span className="font-weight-bold">{roomEvent.name}</span> ?</h3>
                            </div>
                            ) : ""}
                            {(roomEvent && roomEvent.isRemoveByAdmin) ? (
                                <div className="modal-body">
                                <h3 className="text-center text-info">Bạn muốn HỦY XÓA Sự Kiện: <span className="font-weight-bold">{roomEvent.name}</span> ?</h3>
                            </div>
                            ) : ""}
                            <div className="modal-footer">
                                <button type="button" className="btn btn-red" data-dismiss="modal">Hủy</button>
                                {this.state.loading ? 
                                (
                                <button style={{width: "120px"}} className="btn btn-red" type="button" disabled>
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    Xác nhận...
                                </button>
                                ) :
                                (
                                <button 
                                    style={{width: "120px"}} 
                                    type="button" 
                                    className="btn btn-red"
                                    onClick={this.deleteOrActiveRoomEvent}>Xác nhận</button>    
                                )}                        
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}